

export interface IGroup {
  groupID: number;
  name: string;
}

export class CGroup implements IGroup {
  public groupID = 0;
  public name = '';
}
